import React from 'react';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import PropTypes from 'prop-types';
// { geocodeByAddress, geocodeByPlaceId } from 'react-places-autocomplete';
import GoogleMapsLoader from 'google-maps';
import Input from 'components/Input';
import Button from 'components/Button';
import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';

import './styles.scss';


class ToMe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '', modalOpen: false, modalInput: '', position: {}
    };

    this.GOOGLE_MAP = null;

    GoogleMapsLoader.KEY = 'AIzaSyCRN2DYEwpJpX7d1oMDNiSY_YzDe0nFM9I';
    GoogleMapsLoader.LIBRARIES = ['places'];
    GoogleMapsLoader.load((map) => {
      this.GOOGLE_MAP = map.maps.places;
      console.log(map.maps);
    });
  }

  modalHandl = (e) => {
    e.preventDefault();

    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen
    }));
  }

  inputChangHandl = (e) => {
    this.setState({ value: e.target.value });
  }

  inputModalChangHandl = (e) => {
    this.setState({ modalInput: e });
  }

  handleSelect = (address, placeId) => {
    console.log({ address, placeId });


    // address
    geocodeByAddress(address)
      .then((results) => {
        const firstElement = results[0];
        const lng = firstElement.geometry.location.lng();
        const lat = firstElement.geometry.location.lat();
        console.log(lng, lat);
        this.setState({
          value: address, modalInput: '', modalOpen: false, position: { lat, lng }
        });
      });
  }

  renderSuggestion = ({ suggestion }) => (
    <div className="autocomplete_item">
      <i className="material-icons">&#xE0C8;</i>
      <span>
        {suggestion}
      </span>
    </div>
  );


  render() {
    return (
      <div className="to-me">
        { !this.state.modalOpen ? <Input
          placeholder="Delivery address"
          changeHandl={this.inputChangHandl}
          onClickHandl={this.modalHandl}
          value={this.state.value}
          readonly={this.isReadOnly}
        /> : null
        }
        <Button
          disabled={this.state.value === ''}
          onClick={this.props.saveDeliveryHandl(this.state.position, this.state.value)}
        >
          Next
        </Button>

        <Modal
          isOpen={this.state.modalOpen}
        >
          <ModalHeader
            iconType="cross"
            backHandl={this.modalHandl}
          >
            Provide an address
          </ModalHeader>
          <PlacesAutocomplete
            inputProps={{
              value: this.state.modalInput,
              onChange: this.inputModalChangHandl,
              placeholder: 'Delivery address',
              autoFocus: true
            }}
            renderSuggestion={this.renderSuggestion}
            onSelect={this.handleSelect}
            onError={() => console.log('Adress not found')}
            options={{
              types: ['address']
            }}
            classNames={{
              root: 'autocomplete',
              input: 'autocomplete_input',
              autocompleteContainer: 'autocomplete_container'
            }}
          />
        </Modal>


      </div>
    );
  }
}

ToMe.propTypes = {
  saveDeliveryHandl: PropTypes.func.isRequired
};

export default ToMe;




// WEBPACK FOOTER //
// ./src/pages/Delivery/components/ToMe/index.js